<script>
import SalePoolDetails from '@/components/Launchpad/SalePoolDetails';
import Header from '@/components/Launchpad/PreSaleHeader';
import Countdown from '@/components/Launchpad/SimpleCountdown';
import SimpleSaleProcess from '@/components/Launchpad/SimpleSaleProcess';
import Button from '@/components/Button';
import { mapState, mapGetters } from 'vuex';
import { products } from '@/constants/launchpad';

export default {
  name: 'Simplesale',
  components: {
    SalePoolDetails,
    Header,
    Countdown,
    SimpleSaleProcess,
    Button,
  },
  data: () => ({
    timer: null,
    iteration: 0,
  }),
  async mounted() {
    if (this.chainId === this.saleChainId) {
      await this.$store.dispatch('Simplesale/getSaleInfo', {
        saleId: this.productParams.id,
        stakeToken: this.stakeToken,
        pid: this.saleCampaign,
      });
    }
  },
  computed: {
    ...mapState({
      ethAddress: (state) => state.User.ethAddress,
      chainId: (state) => state.User.chainId,
    }),
    ...mapGetters('Simplesale', [
      'allowance',
      'stage',
      'closedAfter',
      'activeAfter',
      'notStartedYet',
      'solana',
      'saleId',
    ]),
    saleCampaign() {
      return this.$route.params.pid;
    },
    isAllowedChain() {
      return [1, 4, 56, 97, 43113, 43114].includes(this.chainId);
    },
    productParams() {
      return products[this.saleCampaign] || {};
    },
    saleChainId() {
      return this.productParams.chainId;
    },
    stakeToken() {
      return this.productParams?.stakeToken || 'MILK2';
    },
  },
  methods: {
    init() {
      if (!this.timer) {
        this.timer = setInterval(async () => {
          this.iteration += 1;
          const oldStage = this.stage;
          const newStage = await this.$store.dispatch('Simplesale/getStage');
          if (oldStage !== newStage || this.iteration > 15) {
            this.iteration = 0;
            clearInterval(this.timer);
          }
        }, 5000);
      }
    },
  },
};
</script>

<template>
  <div class="main-wrap launchpad simplesale main-wrap--narrow">
    <div v-if="!isAllowedChain">
      <v-row justify="center">
        <h1>{{ $t('upcoming.ethereum-only') }}</h1>
      </v-row>
    </div>
    <div v-else-if="Object.keys(productParams).length === 0">
      <v-row justify="center">
        <h1>{{ $t('upcoming.no-products') }}</h1>
      </v-row>
    </div>
    <v-container class="mt-10 mb-5" v-else>
      <Countdown :chain="chainId === saleChainId" :saleId="productParams.id" @callInit="init" />
      <Header :product="productParams" :chain="chainId === saleChainId" />
      <SimpleSaleProcess
        v-if="chainId === saleChainId"
        :stakeToken="stakeToken"
        :hasClaim="productParams.hasClaim"
      />
      <SalePoolDetails :product="productParams" />
      <v-row>
        <v-col cols="12" class="my-10 text-center">
          <Button to="/staking/milk2">{{ $t('launchpad.staking') }}</Button>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<style lang="scss"></style>
